import { SkinService } from "src/app/shared/api/skins.service";
import { ColumnDataType, Resource } from "../../shared/model/resource";
import { skinResource } from "../skins/skin.resource";

export const equipeResource: Resource = {
    nomeEntidade: {
        singular: 'Equipe',
        plural: 'Equipes'
    },
    fieldPk: 'uuid',
    fieldName: 'nome',
    route: {
        url: 'equipes',
    },
    enableSaveAndNew: true,
    colunas: [
        {
            field: 'nome',
            label: 'Nome',
            required: true,
        },
        {
            field: 'skin',
            label: 'Skin',
            type: ColumnDataType.Lookup,
            lookupConfiguration: {
                colunas: skinResource.colunas,
                service: SkinService,
                fieldName: 'nome',
                fieldPk: 'uuid'
            },
            getValueBeforSave: (value: any) => {
                return value?.uuid || null;
            },
            calculateDisplayValue(entity) {
                return entity?.nome || '';
            },
        },
        {
            field: 'exibir_media_relatorio',
            label: 'Exibir média no relatório',
            type: ColumnDataType.Checkbox,
            sizeColumn: 'col-12',
            calculateDisplayValue: (value) => value ? 'Sim' : 'Não',
            unAvailableOnList: true
        },
        {
            field: 'exibir_relatorio',
            label: 'Exibir relatório',
            type: ColumnDataType.Checkbox,
            sizeColumn: 'col-12',
            calculateDisplayValue: (value) => value ? 'Sim' : 'Não',
            unAvailableOnList: true
        },
        {
            field: 'exibir_grafico_roda',
            label: 'Exibir gráfico de roda',
            type: ColumnDataType.Checkbox,
            sizeColumn: 'col-12',
            calculateDisplayValue: (value) => value ? 'Sim' : 'Não',
            unAvailableOnList: true
        },
        {
            field: 'exibir_grafico_barras',
            label: 'Exibir gráfico de barras',
            type: ColumnDataType.Checkbox,
            sizeColumn: 'col-12',
            calculateDisplayValue: (value) => value ? 'Sim' : 'Não',
            unAvailableOnList: true
        },
        {
            field: 'exibir_matriz_de_impacto',
            label: 'Exibir matriz de impacto',
            type: ColumnDataType.Checkbox,
            sizeColumn: 'col-12',
            calculateDisplayValue: (value) => value ? 'Sim' : 'Não',
            unAvailableOnList: true
        },
        {
            field: 'exibir_oportunidades_de_desenvolvimento',
            label: 'Exibir oportunidades de desenvolvimento',
            type: ColumnDataType.Checkbox,
            sizeColumn: 'col-12',
            calculateDisplayValue: (value) => value ? 'Sim' : 'Não',
            unAvailableOnList: true
        },
    ],
    actions: [],
    availableReferences: []
}
